// Product sendTypes describes available modes; order requests contain one selected mode.
export function applyCheckoutSendType(items = [], selectedSendType = 0) {
  const sendTypes = String(selectedSendType).trim();
  if (!["0", "1"].includes(sendTypes)) throw new Error("Checkout sendType must be 0 or 1");
  return items.map(item => ({ ...item, sendTypes }));
}
